import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = ({ hero }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center overflow-hidden bg-gray-900">
      {/* Background Logo with Blur */}
      <div className="absolute inset-0 flex items-center justify-center opacity-10">
        <img 
          src="/assets/logo-final.png" 
          alt="Background" 
          className="w-[800px] h-auto blur-3xl"
        />
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-orange-500/30 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-yellow-500/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 lg:py-40">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-gray-800/80 backdrop-blur-sm border border-orange-500/30 rounded-full px-4 py-2 mb-8 shadow-sm">
            <Sparkles className="w-4 h-4 text-orange-400" />
            <span className="text-sm font-medium text-gray-300">Votre partenaire digital</span>
          </div>

          {/* Title */}
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            {hero.title}
          </h1>

          {/* Subtitle */}
          <p className="text-xl lg:text-2xl text-gray-300 mb-10 leading-relaxed">
            {hero.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={() => scrollToSection('contact')}
              size="lg"
              className="bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              {hero.ctaText}
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              onClick={() => scrollToSection('services')}
              size="lg"
              variant="outline"
              className="border-2 border-gray-600 hover:border-orange-500 text-gray-200 hover:text-orange-400 rounded-full px-8 py-6 text-lg font-semibold bg-gray-800/80 backdrop-blur-sm transition-all duration-300"
            >
              Voir les tarifs
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
